<template>
  <div>
    <slot :data="measurementResults" />
  </div>
</template>

<script>
  const EVENT_CREATE = 'create';
  const EVENT_DESTROY = 'destroy';

  export default {
    name: 'PrDataAdapter',

    props: {
      measurements: {
        type: Array,
        required: true,
      },
      sampleToken: {
        type: String,
        default: null,
      },
      hasLiveUpdate: {
        type: Boolean,
        default: true,
      },
      doSkipDataFetching: {
        type: Boolean,
      },
    },

    data: () => ({
      measurementResults: [],
    }),

    watch: {
      measurements: {
        handler(measurements, measurementsOld) {
          if (this.doSkipDataFetching) {
            this.measurementResults = this.measurements;
            return;
          }

          const initMeasurements = () => {
            if (measurementsOld) {
              const measurementsOldDict = this.measurementResults.reduce(
                (dictionary, measurement) => {
                  dictionary.set(measurement.id, measurement);
                  return dictionary;
                },
                new Map(),
              );

              return measurements.map((measurement) => {
                const measurementOld = measurementsOldDict.get(measurement.id);
                if (measurementOld) {
                  return {
                    ...measurement,
                    data:
                      (measurementOld.data?.length > measurement.data?.length
                        ? measurementOld.data
                        : measurement.data) ?? [],
                  };
                }
                return {
                  ...measurement,
                  data: measurement.data ?? [],
                };
              });
            }
            return measurements.map((measurement) => ({
              ...measurement,
              data: measurement.data ?? [],
            }));
          };

          this.measurementResults = initMeasurements();
        },
        immediate: true,
      },
    },

    created() {
      this.$emit(EVENT_CREATE);
    },

    beforeDestroy() {
      this.$emit(EVENT_DESTROY);
    },
  };
</script>
